import styled from 'styled-components';

export const LeaderboardsModalContainer = styled.div`
    width: 620px;
    max-height: 600px;
    padding: 25px;
    overflow: scroll;

    background-color: #000;
    border-radius: 16px;
    border: 1px solid #353535;
    position: relative;

    display: flex;
    justify-content: center;
`;

export const FormModalContent = styled.div`
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const YoutubeVideoModalContent = styled.div`
    width: 275px;
`;

export const Input = styled.input`
    width: 100%;
    height: 30px;
    border-radius: 2px;
    background-color: rgba(239, 240, 242, 0.18);
    border: none;
    padding: 15px;
    color: white;
    font-size: 14px;
    outline: none;
`;

export const SaveButton = styled.button`
    height: 30px;
    border-radius: 100px;
    background-color: #ffffff;
    color: #fc3d40
    font-size: 14px;
    font-weight: bold;
    padding: 0 20px;
    outline: none;

    &:disabled {
        opacity: 0.5;
    }
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/GymTvConfigurationsModal/Modals/style.js